


































































import Vue from 'vue'

export default Vue.extend({
  props: {
    maxPage: Number,
    searchDone: Boolean,
    value: Number,
    pages: Array as () => number[]
  },

  methods: {
    buildPageUrlQuery (page: number) {
      const query = this.$route.query

      return Object.assign({}, query, { page })
    },
  }
})
